import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { conversationalSettingsCacheKeys } from "./constants";
import type { ConversationalSettingsResult, PutConversationalSettingsProps } from "./types";

export const putConversationalSettings = reactQueryMutationAdapter(
  conversationalSettingsCacheKeys,
  (props: PutConversationalSettingsProps): Promise<ConversationalSettingsResult> => {
    return fetch(`/${props.appGroupId}/conversational/settings`, "PUT", {
      brand_guideline_id: props.brandGuidelineId,
      chat_setting: props.chatSetting,
    });
  }
);
